import { render, staticRenderFns } from "./ProfileLimits.vue?vue&type=template&id=67acc521&"
import script from "./ProfileLimits.vue?vue&type=script&lang=js&"
export * from "./ProfileLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports